export type ArrivalTimeFieldMode = 'hidden' | 'editable' | 'disabled'

type PaymentLinkSignals = {
  confirmationRequest?: string | null
  isInternal?: boolean | null
}

// Payment-link inventory is internal and linked to a confirmation request.
// Fast-pass and venue inventory checkouts are neither.
export function isPaymentLinkCheckout(args: PaymentLinkSignals): boolean {
  return Boolean(args.confirmationRequest) || args.isInternal === true
}

export function getArrivalTimeFieldMode(
  args: PaymentLinkSignals & {
    inventoryType?: string | null
    arrivalTime?: number | null
  }
): ArrivalTimeFieldMode {
  if (args.inventoryType !== 'PACKAGE') return 'hidden'
  if (isPaymentLinkCheckout(args)) {
    return args.arrivalTime == null ? 'hidden' : 'disabled'
  }
  // Inventory checkouts collect a time only when the booking does not have one.
  // Fast pass stores null; venue checkout omits the field (undefined).
  if (args.arrivalTime == null) return 'editable'
  return 'hidden'
}
